<template>
  <div>
    <neibu />
  </div>
</template>

<script>
// 获取接口地址
import Neibu from '../components/nbsy/neibu.vue'

export default {
  name: 'Nbsy',
  components: {
    // sideMenu,
    // Header,
    Neibu
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
